import client from '../httpClient';

const mokuhyoSetResisterApi = (params) => {
  return client.post('/target-settings/', JSON.stringify(params));
};

export default mokuhyoSetResisterApi;
